module.exports = __webpack_public_path__ + "static/BMC-29520c9601f723f62195039b7bf93bc7.pdf";